import { proxy } from 'valtio';

// What a page adds to the header while it is mounted:
// - title: a translation key, for a page the menu does not lead to. It wins
//   over the menu's title.
// - back: show a back button before the title (a list with showBackButton).
export const headerStore = proxy({
    title: null,
    back: false,
});
